<div class="app-wrapper">
  <app-connection-status-banner [status]="connectionBannerStatus()" />
  <router-outlet></router-outlet>

  <app-screen-size-orientation-layer></app-screen-size-orientation-layer>
</div>
